"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedstoresm = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedstoresm` : '') + (description ? ` desc-brandedstoresm` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedstoresm"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedstoresm"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M3 4C3 3.44772 3.44772 3 4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M3 16H21V21H3V16Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M3 15H21V16H3V15Z",
    fill: "#FFC599"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 15V16H21V15H3Z",
    fill: "#FFC599"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M8 12H16V21H8V12Z",
    fill: "#8AE6EB"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 21V12H8V21H9V13H15V21H16Z",
    fill: "#6E6E6E"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 21V12H12.5V21H11.5Z",
    fill: "#6E6E6E"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M7 11L8 7H16L17 11H7Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 13V11H17V13H7Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 12.5H7V11.5H17V12.5Z",
    fill: "#FFC599"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M2 3.5C2 3.22386 2.22386 3 2.5 3H21.5C21.7761 3 22 3.22386 22 3.5C22 3.77614 21.7761 4 21.5 4H2.5C2.22386 4 2 3.77614 2 3.5Z",
    fill: "#F26B1C"
  }));
};
var _default = exports.default = brandedstoresm;